// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"Paragraph_Paragraph__3VVaf","FootnoteLink":"Paragraph_FootnoteLink__cRt8M"};